import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "fr", label: "Français" },
  { code: "de", label: "Deutsch" },
  { code: "es", label: "Español" },
  { code: "pt", label: "Português" },
];

export default function LanguageSwitcher({ textColor = "text-foreground-800" }: { textColor?: string }) {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const current = LANGUAGES.find((l) => l.code === i18n.language) || LANGUAGES[0];

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className={`flex items-center gap-1.5 rounded-full px-3 py-2 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors hover:bg-background-100/70 ${textColor}`}
        aria-label="Language"
      >
        <i className="ri-global-line text-base"></i>
        <span className="hidden sm:inline">{current.label}</span>
        <span className="sm:hidden uppercase">{current.code}</span>
        <i className={`ri-arrow-down-s-line text-base transition-transform ${open ? "rotate-180" : ""}`}></i>
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-44 rounded-lg border border-background-200 bg-background-50 p-1.5 text-foreground-900">
          {LANGUAGES.map((l) => (
            <button
              key={l.code}
              type="button"
              onClick={() => {
                i18n.changeLanguage(l.code);
                setOpen(false);
              }}
              className={`flex w-full items-center justify-between rounded-md px-3 py-2 text-sm text-left whitespace-nowrap cursor-pointer transition-colors ${
                l.code === i18n.language
                  ? "bg-primary-100 text-primary-800 font-medium"
                  : "hover:bg-background-100 text-foreground-700"
              }`}
            >
              {l.label}
              {l.code === i18n.language && <i className="ri-check-line"></i>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}